export function useMobileCheck(currentWidth) {
  return currentWidth >= 1200;
}
